import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../../services/api';
import MapComponent from '../../../components/MapComponent';
import './ReceiptMap.css';

const ReceiptMapPage = () => {
  const { id } = useParams(); // ID квитанции
  const navigate = useNavigate();
  
  const [receiptDetails, setReceiptDetails] = useState(null);
  const [mapCenter, setMapCenter] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const defaultZoom = 15;

  const fetchReceiptDetails = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(`/receipts/${id}`);
      //console.log("Получен ответ от API:", response);
      setReceiptDetails(response);
  
      if (response && response.latitude && response.longitude) {
        const lat = parseFloat(response.latitude);
        const lng = parseFloat(response.longitude);
        if (!isNaN(lat) && !isNaN(lng)) {

          setMapCenter([lat, lng]);
        } else {

          setMapCenter([55.7558, 37.6176]); // fallback
        }
      } else {

        setMapCenter([55.7558, 37.6176]); // fallback
      }
      
      setError('');
    } catch (e) {

      const errorMessage = e.response?.message || 'Ошибка при загрузке деталей квитанции';
      setError(errorMessage);
      setReceiptDetails(null);

      setMapCenter([55.7558, 37.6176]); // fallback
    } finally {
      setIsLoading(false);
    }
  };
  

  useEffect(() => {
    fetchReceiptDetails();
  }, [id]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleMarkerClick = () => {
    navigate(`/courier/receipts/${id}`);
  };

  // Не рендерим карту, пока не получены координаты
  if (isLoading || mapCenter === null) {
    return (
      <div className="receipt-map-page loading">
        Загрузка деталей квитанции...
      </div>
    );
  }

  if (error) {
    return (
      <div className="receipt-map-page error">
        <p>{error}</p>
        <button onClick={fetchReceiptDetails}>Попробовать снова</button>
      </div>
    );
  }

  return (
    <div className="receipt-map-page">
      <button className="back-button" onClick={handleGoBack}>
        ← Назад
      </button>
      <div style={{ height: '100%', width: '100%' }}>
        <MapComponent
          center={mapCenter}
          zoom={defaultZoom}
          receipts={receiptDetails ? [receiptDetails] : []}
          onMarkerClick={handleMarkerClick}
        />
      </div>
    </div>
  );
};

export default ReceiptMapPage;
